export const COPY = {
  TOOLTIPS: {
    GAMES_AVAILABLE: 'Gameplays',
    LOCKED_TASK:
      'This task is locked. You must complete the prerequisites before undertaking this task.',
    USER_POINTS: 'Points available',
    NOTIFICATIONS: 'Messages',
  },
  HEADER_NAV: {
    POINTS: 'POINTS: ',
  },
  SIDENAV: {
    HOME: 'Home',
    MISSIONS: 'Missions',
    MY_BADGES: 'My Badges',
    PRIVACY_POLICY: 'Privacy Policy',
    MISSION_REWARD_OVERVIEW: 'Mission Reward Overview',
    COPYRIGHT: 'Copyright ©2022 BI WORLDWIDE™.\nAll rights reserved.',
  },
  BADGES: {
    NO_BADGES: 'You have no badges.',
    CALL_TO_ACTION: 'Begin your first Mission to start earning badges!',
    MISSIONS_LINK: 'My Missions',
    VIEW_BADGES_LINK: 'View All Badges',
    MY_RECENT_BADGE: 'My Recent Badges',
    ONE_BADGE: "You've earned your first badge!",
    FEW_BADGES: 'Great work! Here are your latest badges.',
    MANY_BADGES: 'Wow, great work on your badge collection!',
    EARNED: 'Earned',
  },
  LEVEL_COMPONENT: {
    TITLE: 'My Level',
    LEVEL: 'Level ',
    LEVEL_CREDITS: 'Level Credits',
    NEXT_LEVEL: 'Next:',
    TOP_LEVEL: 'Congrats! You are at top level!',
  },
  MAIN_BANNER: {
    HEADER: 'Missions on Xchange',
    SUB_HEADER: 'Complete Missions. Level Up. Earn Rewards.',
    LEVEL: 'Level: ',
    LEVEL_CREDITS: 'Level Credits: ',
    NEXT_LEVEL: 'Next Level: ',
    TOP_LEVEL: 'Congrats! You are at top level!',
  },
  FEATURED_MISSION: {
    NO_MISSIONS_FOUND: {
      HEADER: 'See your latest Missions',
      DESCRIPTION:
        'New Featured Missions are added all the time, so check Missions on Xchange often for more ways to earn. Head to your Missions page for more content and keep moving towards your next level.',
      BUTTON_TEXT: 'View Missions',
    },
    BUTTON_TEXT: 'Start Mission',
    ARIA: {
      FORWARD: 'Advance slide',
      BACKWARD: 'Go back to previous slide',
    },
  },
  HOME_SCREEN: {
    HEADER: 'Missions',
    MISSION_CATEGORIES: 'Mission Categories',
    MY_DASHBOARD: {
      HEADER: 'My Dashboard',
      COMMUNICATIONS: 'Communications',
      NO_ARTICLES_HEADER: "You're all caught up!",
      NO_ARTICLES_SUBHEADING:
        'There are no new articles to read. Please check back soon!',
    },
  },
  NO_ACCESS: {
    HEADER: 'Missions are currently unavailable',
    LINK: 'Click here to go back to Xchange',
  },
  MISSIONS: {
    NO_MISSIONS: {
      HEADER: 'Mission: Complete!',
      SUB_HEADER: `You're all caught up on available missions in this category. Check back soon for new opportunities to learn more and earn!`,
    },
    HEADER: 'Missions',
    SUB_HEADER: 'Complete Missions. Level Up. Earn Rewards.',
    FEATURED: 'Featured',
    EARNED: 'Earned',
    LOCKED: 'Locked',
    FEATURED_MISSION: 'Featured Mission',
    EXPIRING_IN: (daysRemaining: number) => `Expiring in ${daysRemaining} days`,
    EXPIRING_TOMORROW: 'Expiring in 1 day',
    EXPIRING_TODAY: 'Expiring Today',
    EXPIRED: 'Expired',
    EXPIRING_SOON_NO_DATE: 'Expiring soon',
    IN_PROGRESS: 'In progress',
    REPEATABLE: 'Repeatable',
    TOGGLE_OPTIONS: ['Missions', 'Leaderboard & Activity'],
    FILTER: 'Filter',
    VIEW_RESULTS: 'View Results',
    MISSION_ACTIONS: {
      CATEGORY: 'Mission Category',
      STATUS: 'Status',
    },
  },
  MODAL: {
    BTN_COPY_LINK: 'Copy Link',
    NON_DETAILS_HEADER: 'Return to Mission',
    LABEL_TASKS: 'Tasks',
    MSG_LINK_COPIED_SUCCESS: 'Copied!',
    SECTION_LABEL_REWARDS: 'Rewards',
    SECTION_LABEL_TASKS: 'Tasks',
  },
  LEADERBOARD: {
    NO_LEADERBOARD:
      'Climb to the top of the Leaderboard. Complete a Mission today!',
    HEADER: 'Mission Completion Leaders',
    TERMS_AND_CONDITIONS:
      'Complete Missions to earn your spot on the leaderboard! Note: Leaderboard ranks reset at 12:00am CST at the beginning of the leaderboard period.',
    YOUR_COMPLETED: 'Your Completed Missions',
    MISSIONS: 'Missions',
    SINGLE_MISSION: 'Mission',
  },
  LATEST_ACTIVITY: {
    HEADER: 'Latest activity',
    LESS_THAN: 'less than 1 hour ago.',
    HOURS: 'hours ago.',
    HOUR: 'hour ago.',
    DAY: 'day ago.',
    DAYS: 'days ago.',
  },
  ARTICLES: {
    BACK: 'Back',
  },
};
